// Admin panel look — the ONE place to change the admin's brand colours, logos,
// favicon and name. Edit here, rebuild, and it applies everywhere.
// Paths are public URLs (files live in admin/public/, served under /admin/).
// `colors` is written into index.html by siteThemePlugin (vite.config.js) as
// `html:root{…}`, which beats every `:root` rule in src/styles, before any JS runs.
export const SITE = {
  name: 'TENEXCH',
  logo: '/admin/assets/front/logo.png', // header + change-password screen
  loginLogo: '/admin/assets/logo.png', // login + 2FA screens
  logoSmall: '/admin/assets/admin/icon.png', // collapsed sidebar
  favicon: '/favicon.png',
  colors: {
    '--bg-body': '#DFE5E5',
    '--text-body': '#222222',
    '--bg-table': '#FDFBFE',
    '--text-table': '#222222',
    '--bg-primary': '#FFB80C',
    '--text-primary': '#222222',
    '--bg-secondary': '#222222',
    '--text-secondary': '#eeeeee',
    '--bg-op1': '#FFB80C99',
    '--bg-op2': '#22222299',
    '--text-fancy': '#FDCF13',
  },
};
